module.exports = __webpack_public_path__ + "img/speaker.4000fc57.png";